/* Produktseite — Baustein 6, 01.09.2026.

   Vier Aufgaben, die Liquid nicht erledigen kann:

   1. Den Gravur-Konfigurator an seinen Platz schieben. Die App Zepto Product
      Personalizer haengt ihren Kasten als erstes Element ins Kaufformular —
      also noch ueber Stiftfarbe und Anzahl. Der Kunde wurde damit nach der
      Gravur gefragt, bevor er den Stift gewaehlt hatte. Die App laesst nichts
      im Liquid zurueck, deshalb wird der Kasten zur Laufzeit verschoben,
      sobald er auftaucht. Bleibt der Platz leer, blendet das Stylesheet ihn
      aus (.penovia-gravur:empty).

   2. Den Stueckpreis rechnen. Bei den Produkten mit Anzahl-Option ist der
      Variantenpreis der Preis des ganzen Gebindes: 100 Stueck fuer 99,90 €.
      Was ein Stueck kostet, stand nirgends — bei Werbemitteln ist das die
      Zahl, auf die es ankommt.

   3. Die Schriftkacheln der Gravur herrichten: Probe in der jeweiligen
      Schrift oben, Name klein darunter.

   4. Zwei englische Kurzhinweise auf den Karten der verwandten Produkte
      eindeutschen. Sie stehen fest in snippets/product-item-v2.liquid; sie
      dort zu aendern waere ein Eingriff in eine Theme-Datei fuer zwei Woerter.

   Kein jQuery — das Skript wird aus dem Snippet heraus geladen und soll nicht
   davon abhaengen, ob jQuery zu diesem Zeitpunkt schon da ist.
*/
(function () {
  'use strict';

  var knoten = document.getElementById('penovia-produkt-daten');
  if (!knoten) return;

  var daten;
  try {
    daten = JSON.parse(knoten.textContent);
  } catch (e) {
    return;
  }

  var formular = document.getElementById('AddToCartForm');

  /* ---------------------------------------------------------------
     1. Konfigurator an seinen Platz
     --------------------------------------------------------------- */

  function gravurVerschieben() {
    var platz = document.querySelector('[data-gravur-platz]');
    if (!platz || !formular) return;

    var kasten = formular.querySelector('.product-personalizer');
    if (!kasten) return;

    /* Die App legt ihren Kasten in einen eigenen Huellblock direkt unter dem
       Formular. Verschoben wird dieser Huellblock, nicht nur der Inhalt —
       sonst bleibt ein leeres Element an der alten Stelle stehen. */
    var zuVerschieben = kasten;
    while (zuVerschieben.parentNode && zuVerschieben.parentNode !== formular) {
      zuVerschieben = zuVerschieben.parentNode;
    }
    if (zuVerschieben.parentNode !== formular) return;
    if (platz.contains(zuVerschieben)) return;

    platz.appendChild(zuVerschieben);
  }

  if (formular && window.MutationObserver) {
    var beobachter = new MutationObserver(function () {
      gravurVerschieben();
    });
    beobachter.observe(formular, { childList: true, subtree: true });
  }
  gravurVerschieben();

  /* ---------------------------------------------------------------
     2. Stueckpreis
     --------------------------------------------------------------- */

  var stueckfeld = document.querySelector('.penovia-stueckpreis');

  function geld(betrag) {
    /* Der Rest der Seite formatiert mit Shopify.formatMoney; solange die
       Datei geladen ist, benutzen wir dieselbe Funktion, damit auf der Seite
       nicht zwei Schreibweisen nebeneinander stehen. */
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(betrag, daten.geldformat);
    }
    return (betrag / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function aktuelleVariante() {
    var feld = document.getElementById('productSelect');
    var id = feld && feld.value ? String(feld.value) : null;
    var gefunden = null;

    if (id) {
      daten.varianten.forEach(function (v) {
        if (String(v.id) === id) gefunden = v;
      });
      if (gefunden) return gefunden;
    }

    /* Kein brauchbarer Wert im Formularfeld: aus den angehakten Knoepfen lesen. */
    var werte = daten.optionen.map(function (o, i) {
      var haken = document.querySelector('.swatch[data-option-index="' + i + '"] input:checked');
      return haken ? haken.value : null;
    });
    daten.varianten.forEach(function (v) {
      if (gefunden) return;
      var passt = werte.every(function (wert, i) {
        return wert === null || wert === v.werte[i];
      });
      if (passt) gefunden = v;
    });
    return gefunden;
  }

  function stueckpreisZeigen() {
    if (!stueckfeld || daten.anzahlIndex < 0) return;

    var v = aktuelleVariante();
    if (!v) {
      stueckfeld.textContent = '';
      return;
    }

    var stueck = parseInt(v.werte[daten.anzahlIndex], 10);
    if (!stueck || stueck < 2) {
      stueckfeld.textContent = '';
      return;
    }

    stueckfeld.textContent =
      stueck + ' Stück · ' + geld(v.preis) + ' · ' + geld(v.preis / stueck) + ' je Stück';
  }

  document.addEventListener('change', function (e) {
    var z = e.target;
    if (!z || !z.matches) return;
    if (z.matches('#productSelect, .single-option-selector, .swatch input[type="radio"]')) {
      /* Erst nachdem der Handler des Themes die Variante gesetzt hat. */
      window.setTimeout(stueckpreisZeigen, 0);
      window.setTimeout(gravurHerrichten, 400);
      window.setTimeout(gravurHerrichten, 1600);
    }
  });
  stueckpreisZeigen();

  /* ---------------------------------------------------------------
     3. Waehrungskuerzel aus dem Preis nehmen

     layout/theme.liquid setzt window.money_format auf
     shop.money_with_currency_format — "€6,90 EUR". Der Rest des Shops
     rechnet mit shop.money_format, also "€6,90": die Kollektionsseiten,
     die Karten der Startseite, der erste Aufbau dieser Seite. Nur der
     Preis im Kaufbereich bekam das Kuerzel angehaengt, sobald das
     Theme-Skript ihn neu geschrieben hat — beim Laden und bei jedem
     Variantenwechsel.

     Wir haengen es wieder ab, statt window.money_format zu aendern:
     das waere ein Eingriff in eine Theme-Datei fuer eine Zeile, die
     auch der Warenkorb liest.

     (Dass "€6,90" statt "6,90 €" dasteht, ist eine Shop-Einstellung:
     Einstellungen -> Allgemein -> Waehrungsformat. Sie gilt fuer den
     ganzen Shop und laesst sich nicht ueber das Theme setzen.)
     --------------------------------------------------------------- */

  var kuerzel = ' ' + (daten.waehrung || '');

  function kuerzelAbschneiden(el) {
    if (!el || kuerzel === ' ') return;
    var text = el.textContent;
    if (text.slice(-kuerzel.length) === kuerzel) {
      el.textContent = text.slice(0, -kuerzel.length);
    }
  }

  Array.prototype.forEach.call(
    document.querySelectorAll('.enj-product-price, .enj-product-price-compare'),
    function (el) {
      kuerzelAbschneiden(el);
      if (!window.MutationObserver) return;
      /* Schneidet nur ab, wenn etwas abzuschneiden ist — der zweite
         Durchlauf findet nichts mehr und die Schleife endet. */
      new MutationObserver(function () {
        kuerzelAbschneiden(el);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    }
  );

  /* ---------------------------------------------------------------
     4. Schriftkacheln der Gravur

     Die App gibt jede Schrift als ein Element aus, das ihren Namen traegt
     und bereits in dieser Schrift gesetzt ist. Als Kachel gelesen hat das
     zwei Schwaechen: Lange Namen wie "Petitformalscript" passen nicht in
     eine Zeile, und der Kunde sieht das Wort "Greatvibes" statt seines
     eigenen Textes.

     Deshalb bekommt jede Kachel zwei Zeilen: oben eine feste Schriftprobe
     in der jeweiligen Schrift, darunter klein der Name der Schrift in der
     Schrift der Seite.

     Die Probe ist bewusst fest und nicht der eingegebene Gravurtext: Sonst
     stuende der Text siebzehnmal untereinander im Kasten und liefe dem
     Feld darueber davon.

     Das Element selbst bleibt unangetastet: seine Klassen, seine
     data-Attribute und sein eigenes onclick. Geaendert wird nur, was
     darin steht.
     --------------------------------------------------------------- */

  /* ---------------------------------------------------------------
     Trennlinien im Gravurteil — nur zwischen dem, was auch zu sehen ist

     Die App blendet ihre Abschnitte je nach Wahl ein und aus: Wer beim
     BambooTouch "Farbdruck" waehlt, bekommt einen anderen Satz Felder als
     bei "Gravur". Ausgeblendet wird mit display:none — die Elemente
     bleiben also stehen.

     Fuer CSS ist das nicht zu fassen: :first-of-type trifft den ersten
     Abschnitt, auch wenn der unsichtbar ist. Die Linie sass dann am
     zweiten — direkt unter der Linie, die den Gravurteil ohnehin von den
     Optionen trennt. Zwei Striche uebereinander.

     Deshalb setzt das Skript die Linien: Es sucht die sichtbaren
     Abschnitte und gibt allen ausser dem ersten die Klasse
     penovia-trennlinie. Ist keiner sichtbar, faellt der ganze Gravurteil
     weg — sonst bliebe eine Linie ohne Inhalt stehen.
     --------------------------------------------------------------- */

  /* Gefragt ist, ob die App den Abschnitt ausgeblendet hat — nicht, ob er
     gerade auf dem Bildschirm Platz einnimmt. Die gemessene Hoehe taugt
     dafuer nicht: Sobald dieses Skript den Gravurteil einmal ausblendet,
     messen alle Abschnitte darin null, und er bliebe fuer immer aus.

     Das eigene display eines Elements bleibt dagegen 'block', auch wenn
     ein Vorfahr auf display:none steht — genau die Auskunft, die hier
     gebraucht wird. */
  function sichtbar(el) {
    return getComputedStyle(el).display !== 'none';
  }

  function gravurAufraeumen() {
    var teil = document.querySelector('.penovia-gravur');
    if (!teil) return;

    var abschnitte = teil.querySelectorAll('.pplr-wrapper');
    var erster = true;
    var etwasDa = false;

    Array.prototype.forEach.call(abschnitte, function (a) {
      if (!sichtbar(a)) {
        a.classList.remove('penovia-trennlinie');
        return;
      }
      etwasDa = true;
      if (erster) {
        a.classList.remove('penovia-trennlinie');
        erster = false;
      } else {
        a.classList.add('penovia-trennlinie');
      }
    });

    teil.classList.toggle('penovia-ohne-inhalt', !etwasDa);
  }

  /* ---------------------------------------------------------------
     Schritte durchnummerieren

     Jede Ueberschrift im Kasten bekommt ihre Nummer — die des Themes
     ("Stiftfarbe", "Anzahl", "Box") ebenso wie die der Gravur-App
     ("Wuenschen Sie eine Gravur?", "Gravurtext", "Schriftart"). Das
     Stylesheet macht daraus den schwarzen Kreis; hier wird nur gezaehlt.

     Gezaehlt wird zur Laufzeit und nicht in Liquid, weil die App ihre
     Abschnitte je nach Wahl ein- und ausblendet. Eine feste Nummer im
     Markup haette sonst Luecken: Schritt 1, 2, dann 4.
     --------------------------------------------------------------- */

  function abschnitteNummerieren() {
    var kasten = document.querySelector('.penovia-konfigurator');
    if (!kasten) return;

    /* Erst alle Nummern abraeumen — sonst bleibt eine an einem Abschnitt
       haengen, den die App inzwischen ausgeblendet hat. */
    Array.prototype.forEach.call(
      kasten.querySelectorAll('[data-penovia-nr]'),
      function (el) { el.removeAttribute('data-penovia-nr'); }
    );

    var nr = 0;
    Array.prototype.forEach.call(kasten.children, function (block) {
      if (!sichtbar(block)) return;

      if (block.classList.contains('penovia-gravur')) {
        if (block.classList.contains('penovia-ohne-inhalt')) return;
        Array.prototype.forEach.call(block.querySelectorAll('.pplr-wrapper'), function (a) {
          if (!sichtbar(a)) return;
          var kopf = a.querySelector('.pplrlabel');
          if (kopf) { nr += 1; kopf.setAttribute('data-penovia-nr', nr); }
        });
        return;
      }

      var titel = block.querySelector('.title_variant');
      if (titel) { nr += 1; titel.setAttribute('data-penovia-nr', nr); }
    });
  }

  var PROBE = 'Penovia';

  function schriftkachelnAufbauen() {
    var kacheln = document.querySelectorAll('.penovia-gravur .pplr-selecter-item');

    Array.prototype.forEach.call(kacheln, function (k) {
      if (k.getAttribute('data-penovia') !== '1') {
        var name = k.getAttribute('data-name') || k.textContent.trim();
        k.setAttribute('data-penovia', '1');
        k.setAttribute('data-penovia-name', name);
        k.textContent = '';

        var probe = document.createElement('span');
        probe.className = 'penovia-schriftprobe';
        probe.textContent = PROBE;
        k.appendChild(probe);

        var titel = document.createElement('span');
        titel.className = 'penovia-schriftname';
        titel.textContent = name;
        k.appendChild(titel);
      }
      var p = k.querySelector('.penovia-schriftprobe');
      if (p && p.textContent !== PROBE) p.textContent = PROBE;
    });
  }

  /* Die App baut ihren Kasten spaeter und mitunter erneut auf. Der
     Beobachter oben verschiebt ihn dann; hier richten wir die Kacheln
     nach jeder Aenderung neu her. Bereits umgebaute Kacheln erkennt die
     Funktion an data-penovia und laesst sie in Ruhe. */
  /* ---------------------------------------------------------------
     Name der gewaehlten Farbe in die Ueberschrift

     Die Farboptionen stehen als Kreise da — welche Farbe "Anthrazit" und
     welche "Schwarz" ist, sagt der Kreis allein nicht. Der Name der
     gerade gewaehlten Farbe steht deshalb neben der Ueberschrift.
     --------------------------------------------------------------- */

  function optionswertZeigen() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.penovia-konfigurator .penovia-optionswert'),
      function (feld) {
        var i = feld.getAttribute('data-fuer');
        var haken = document.querySelector('.swatch[data-option-index="' + i + '"] input:checked');
        feld.textContent = haken ? haken.value : '';
      }
    );
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.swatch input[type="radio"]')) {
      optionswertZeigen();
    }
  });
  optionswertZeigen();

  /* ---------------------------------------------------------------
     Nicht passende Werte durchstreichen statt ausblenden

     Das Theme rechnet nur ABWAERTS: snippets/linked-options.liquid baut
     eine Kette — Stiftfarbe bestimmt die Anzahl, Stiftfarbe + Anzahl
     bestimmen die Veredelung. Wer die Veredelung wechselt, aendert an der
     Anzahl darueber nichts, weil sie in der Kette vor ihr steht.

     Sichtbar wurde das so: Bei Anzahl 1 verschwand Farbdruck (abwaerts,
     das Theme kann es). Bei Farbdruck blieben die Mengen 1 und 5 stehen,
     als gaebe es sie — aufwaerts, das rechnet niemand.

     Hier wird es gerechnet, und zwar vollstaendig: Ein Wert passt, wenn es
     eine lieferbare Variante gibt, die ihn traegt UND zu allen uebrigen
     angehakten Werten passt. Das schliesst den Fall des Themes mit ein.

     Betroffen sind nur die Gruppen, die penovia-optionen.liquid mit
     --gestrichen kennzeichnet.

     Der angehakte Wert bleibt unangetastet. Ihn zu sperren hiesse, ein
     Formular ohne Auswahl abzuschicken; ihn durchzustreichen hiesse, die
     eigene Wahl als falsch auszuweisen. Passt er nicht mehr, hebt ihn das
     Theme selbst auf. */
  function unpassendeStreichen() {
    var gruppen = document.querySelectorAll('.penovia-optionsgruppe--gestrichen');
    if (!gruppen.length || !daten.varianten) return;

    var gewaehlt = daten.optionen.map(function (o, i) {
      var haken = document.querySelector('.swatch[data-option-index="' + i + '"] input:checked');
      return haken ? haken.value : null;
    });

    Array.prototype.forEach.call(gruppen, function (gruppe) {
      var kasten = gruppe.querySelector('.swatch[data-option-index]');
      if (!kasten) return;
      var index = parseInt(kasten.getAttribute('data-option-index'), 10);

      Array.prototype.forEach.call(gruppe.querySelectorAll('.penovia-wert'), function (feld) {
        var knopf = feld.querySelector('input[type="radio"]');
        if (!knopf) return;

        /* Der angehakte Wert wird nie gestrichen — aber ein Strich von
           vorhin muss weg. Sonst bleibt er an einem Wert kleben, den der
           Kunde gerade erst gewaehlt hat, oder an einem, auf den das Theme
           selbst umgeschaltet hat, weil der alte nicht mehr passte. */
        if (knopf.checked) {
          feld.classList.remove('penovia-wert--unpassend');
          knopf.disabled = false;
          return;
        }

        var passt = daten.varianten.some(function (v) {
          if (!v.frei || v.werte[index] !== feld.getAttribute('data-value')) return false;
          return gewaehlt.every(function (wert, i) {
            return i === index || wert === null || wert === v.werte[i];
          });
        });

        if (passt) {
          feld.classList.remove('penovia-wert--unpassend');
        } else {
          feld.classList.add('penovia-wert--unpassend');
        }
        knopf.disabled = !passt;
      });
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('#productSelect, .single-option-selector, .swatch input[type="radio"]')) {
      /* Erst nachdem linked-options seine eigene Kette durchgerechnet hat. */
      window.setTimeout(unpassendeStreichen, 0);
      window.setTimeout(unpassendeStreichen, 400);
      window.setTimeout(gravurNachVeredelung, 0);
      window.setTimeout(gravurNachVeredelung, 400);
    }
  });

  /* ---------------------------------------------------------------
     "Ohne Veredelung": die Gravur-App hat dann nichts mehr zu fragen

     Seit dem 03.09.2026 hat die Option Veredelung einen dritten Wert.
     Die App weiss davon nichts und fragte weiter "Wuenschen Sie eine
     Gravur?" — der Kunde waehlte also erst ausdruecklich keine
     Veredelung und wurde danach nach seinem Gravurtext gefragt.

     Der Kasten wird deshalb nicht nur versteckt, sondern die App wird
     ZUERST auf "Ohne Gravur" gestellt, ueber ihren eigenen Klick-Handler.
     Der Grund ist handfest: Ihr verstecktes Feld traegt required. Ein
     leeres Pflichtfeld, das niemand sehen und ausfuellen kann, laesst den
     Browser die Bestellung verweigern — mit einer Meldung ueber ein
     "nicht fokussierbares Formularfeld", die kein Kunde deuten kann.
     Mit gesetztem Wert geht die Bestellung durch, und im Warenkorb steht
     sauber "Ohne Gravur".

     Umgekehrt wird nichts erzwungen: Wer zurueck auf Gravur wechselt,
     bekommt den Kasten wieder und trifft seine Wahl selbst. */
  function gravurNachVeredelung() {
    var kasten = document.querySelector('.penovia-gravur');
    if (!kasten) return;

    var haken = document.querySelector('.penovia-optionsgruppe--veredelung .penovia-wert input:checked');
    var entfaellt = !!haken && haken.value === 'Ohne Veredelung';

    if (entfaellt) {
      var ohne = kasten.querySelector('._pplr_ohne_gravur');
      /* Nur klicken, wenn die App nicht ohnehin schon dort steht — sonst
         liefe der Handler bei jedem Wechsel der Stiftfarbe mit. */
      if (ohne && !ohne.classList.contains('active') && !ohne.classList.contains('pplr-selected')) {
        ohne.click();
      }
    }
    kasten.classList.toggle('penovia-gravur--entfaellt', entfaellt);
  }

  /* linked-options baut seine Kette aus einem MutationObserver heraus auf,
     also NACH diesem ersten Lauf — und nimmt dabei jedem lieferbaren Wert
     das disabled wieder ab, auch denen, die wir gerade gesperrt haben.
     Gemessen beim Bambus-Kugelschreiber: Der Strich stand, der Knopf war
     wieder anklickbar. Deshalb noch einmal, wenn die App und das Theme
     fertig sind — dieselben Zeitpunkte wie beim Gravur-Kasten. */
  unpassendeStreichen();
  window.setTimeout(unpassendeStreichen, 400);
  window.setTimeout(unpassendeStreichen, 1600);
  /* Die App baut ihren Kasten erst nach dem Laden — vorher gibt es nichts
     zu verstecken. */
  window.setTimeout(gravurNachVeredelung, 400);
  window.setTimeout(gravurNachVeredelung, 1600);

  function gravurHerrichten() {
    schriftkachelnAufbauen();
    gravurAufraeumen();
    abschnitteNummerieren();
  }

  if (window.MutationObserver) {
    var kachelwache = new MutationObserver(function () {
      gravurHerrichten();
    });
    var platzFuerWache = document.querySelector('[data-gravur-platz]');
    /* attributeFilter auf style: Das Ein- und Ausblenden der App laeuft
       ueber inline gesetztes display. Auf class hoert der Beobachter
       bewusst nicht — sonst loeste er sich mit den Klassen, die er selbst
       setzt, endlos wieder aus. */
    if (platzFuerWache) {
      kachelwache.observe(platzFuerWache, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  }
  gravurHerrichten();
  window.setTimeout(gravurHerrichten, 1500);
  window.setTimeout(gravurHerrichten, 4000);

  /* ---------------------------------------------------------------
     5. Deutsche Kurzhinweise auf den Karten der verwandten Produkte
     --------------------------------------------------------------- */

  var uebersetzt = { 'Select Option': 'Auswählen', 'Quickview': 'Schnellansicht' };

  function hinweiseEindeutschen() {
    var karten = document.querySelectorAll('.related-product [data-original-title]');
    Array.prototype.forEach.call(karten, function (el) {
      var alt = el.getAttribute('data-original-title');
      if (uebersetzt[alt]) {
        el.setAttribute('data-original-title', uebersetzt[alt]);
        el.setAttribute('title', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hinweiseEindeutschen);
  } else {
    hinweiseEindeutschen();
  }
  window.setTimeout(hinweiseEindeutschen, 1500);
})();
